(function () {
  "use strict";

  var STORAGE_KEY = "fishystuff.theme-boot.v1";
  var CACHE_VERSION = 1;
  var MAX_STORED_CHARS = 1024;
  var NAMED_THEMES = Object.freeze([
    "fishy",
    "dark",
    "abyss",
    "light",
    "silk",
    "cupcake",
    "caramellatte",
  ]);

  function isRecord(value) {
    if (!value || typeof value !== "object" || Array.isArray(value)) return false;
    var prototype = Object.getPrototypeOf(value);
    return prototype === Object.prototype || prototype === null;
  }

  function exactFields(value, expected) {
    var fields = Object.keys(value).sort();
    return fields.length === expected.length
      && fields.every(function (field, index) { return field === expected[index]; });
  }

  function decodeSelection(value) {
    if (!isRecord(value)) return null;
    if (value.kind === "system" && exactFields(value, ["kind"])) {
      return { kind: "system" };
    }
    if (
      value.kind === "named"
      && exactFields(value, ["kind", "name"])
      && NAMED_THEMES.includes(value.name)
    ) {
      return { kind: "named", name: value.name };
    }
    return null;
  }

  function readSelection() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw || raw.length > MAX_STORED_CHARS) return null;
      var cache = JSON.parse(raw);
      if (
        !isRecord(cache)
        || !exactFields(cache, ["cacheVersion", "selection", "sourceRevision"])
        || cache.cacheVersion !== CACHE_VERSION
        || !Number.isSafeInteger(cache.sourceRevision)
        || cache.sourceRevision <= 0
      ) {
        return null;
      }
      return decodeSelection(cache.selection);
    } catch (_error) {
      return null;
    }
  }

  function resolve(selection) {
    if (selection.kind === "named") return selection.name;
    try {
      var query = window.matchMedia("(prefers-color-scheme: dark)");
      return query.matches ? "fishy" : "light";
    } catch (_error) {
      return "fishy";
    }
  }

  var selection = readSelection() || { kind: "system" };
  document.documentElement.setAttribute("data-theme", resolve(selection));
})();
